import { AppDeviceSize } from '../enums/app-device-size';

export const deviceDetection = (displayWidth: number): number => {
  switch (true) {
    case displayWidth < 768:
      return AppDeviceSize.MOBILE;
    case displayWidth < 992:
      return AppDeviceSize.TABLET;
    case displayWidth < 1100:
      return AppDeviceSize.SMALLDESKTOP;
    case displayWidth < 1366:
      return AppDeviceSize.REGULARDESKTOP;
    default:
      return AppDeviceSize.DESKTOP;
  }
};
